import { render, staticRenderFns } from "./ErrorMsg.vue?vue&type=template&id=e46232d4&scoped=true&"
import script from "./ErrorMsg.vue?vue&type=script&lang=js&"
export * from "./ErrorMsg.vue?vue&type=script&lang=js&"
import style0 from "./ErrorMsg.vue?vue&type=style&index=0&id=e46232d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e46232d4",
  null
  
)

component.options.__file = "ErrorMsg.vue"
export default component.exports